import { render, staticRenderFns } from "./MainBox.vue?vue&type=template&id=dcb20644&scoped=true"
import script from "./MainBox.vue?vue&type=script&lang=js"
export * from "./MainBox.vue?vue&type=script&lang=js"
import style0 from "./MainBox.vue?vue&type=style&index=0&id=dcb20644&prod&lang=less&scoped=true"
import style1 from "./MainBox.vue?vue&type=style&index=1&id=dcb20644&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb20644",
  null
  
)

export default component.exports